const DEFAULT_PAGE = 1;
const DEFAULT_ROWS_PER_PAGE = 25;
const DEFAULT_SELECT_LIST = [25, 50, 100];
const getPaginationRange = (currentPage, totalPages) => {
  if (!totalPages || totalPages <= 0) return [];

  if (totalPages <= 4) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  if (currentPage === 1) return [1, 2, "...", totalPages];
  if (currentPage === 2) return [1, 2, 3, "...", totalPages];
  if (currentPage === 3) return [1, 2, 3, 4, "...", totalPages];
  if (currentPage === totalPages) return [1, "...", totalPages - 1, totalPages];
  if (currentPage === totalPages - 1)
    return [1, "...", totalPages - 2, totalPages - 1, totalPages];
  if (currentPage === totalPages - 2)
    return [
      1,
      "...",
      totalPages - 3,
      totalPages - 2,
      totalPages - 1,
      totalPages,
    ];

  return [
    1,
    "...",
    currentPage - 1,
    currentPage,
    currentPage + 1,
    "...",
    totalPages,
  ];
};

export { DEFAULT_PAGE, DEFAULT_ROWS_PER_PAGE, DEFAULT_SELECT_LIST,getPaginationRange };
